import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export const useApplyReceiptItemDiscount = () => {
  const { projectId, receiptId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<void, Error, { receiptItemId: string; discountId: string }>({
    mutationFn: ({ receiptItemId, discountId }) =>
      apiClient.put(`/v1/projects/${projectId}/receipt-items/${receiptItemId}/discount`, {
        discountItemUuid: discountId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['receipts', projectId] });
      queryClient.invalidateQueries({ queryKey: ['receipt', receiptId] });
    },
  });
};
